export const TOOLS = [
  { id: "writer", code: "AX-01", name: "AIBA Writer", kind: "text", lookup_key: "tool_writer", price: 29,
    tagline: "Rédaction augmentée", icon: "PenTool", span: "lg:col-span-7",
    desc: "Génère articles, e-mails et pages de vente structurés et prêts à publier.",
    image: null, promptLabel: "Décrivez le contenu à rédiger", placeholder: "Ex : un e-mail de bienvenue pour mes nouveaux clients SaaS…" },
  { id: "chat", code: "AX-02", name: "AIBA Chat", kind: "text", lookup_key: "tool_chat", price: 19,
    tagline: "Assistant conversationnel", icon: "MessageSquare", span: "lg:col-span-5",
    desc: "Un assistant IA direct pour répondre à toutes vos questions professionnelles.",
    image: null, promptLabel: "Votre question", placeholder: "Ex : explique-moi le tunnel de conversion AARRR…" },
  { id: "voice", code: "AX-03", name: "AIBA Voice", kind: "voice", lookup_key: "tool_voice", price: 39,
    tagline: "Synthèse & clonage vocal", icon: "AudioLines", span: "lg:col-span-4",
    desc: "Transforme n'importe quel texte en voix naturelle et téléchargeable.",
    image: null, promptLabel: "Texte à vocaliser", placeholder: "Ex : Bienvenue au Laboratoire AIBA…" },
  { id: "seo", code: "AX-04", name: "AIBA SEO", kind: "text", lookup_key: "tool_seo", price: 49,
    tagline: "Croissance organique", icon: "TrendingUp", span: "lg:col-span-4",
    desc: "Mots-clés, titres, méta-descriptions et recommandations en un clic.",
    image: null, promptLabel: "Sujet / page à optimiser", placeholder: "Ex : café bio à Lyon…" },
  { id: "suite", code: "AX-05", name: "AIBA Suite", kind: "text", lookup_key: "tool_suite", price: 149,
    tagline: "Cœur du système · Master", icon: "Suite", span: "lg:col-span-4", master: true,
    desc: "Le module maître : stratégie, contenu et automatisation orchestrés.",
    image: null, promptLabel: "Votre objectif business", placeholder: "Ex : lancer une formation IA à 5 000 € de CA / mois…" },
  { id: "clone", code: "AX-06", name: "Générateur Clone IA", kind: "image", lookup_key: "tool_clone", price: 59,
    tagline: "Génération de clones IA", icon: "Dna", span: "lg:col-span-4",
    desc: "Compose des visuels de clones IA photoréalistes sur mesure.",
    fields: [
      { key: "name", label: "Nom du clone", type: "text", placeholder: "Ex : Nova" },
      { key: "age", label: "Âge", type: "number", placeholder: "Ex : 27" },
      { key: "sex", label: "Sexe", type: "select", options: ["Femme", "Homme", "Non-binaire"] },
      { key: "origin", label: "Type", type: "select", options: ["IA", "Réel"] },
    ],
    image: "https://images.unsplash.com/photo-1737644467636-6b0053476bb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjeWJvcmclMjBhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwZGFya3xlbnwwfHx8fDE3ODQzODMzMDB8MA&ixlib=rb-4.1.0&q=85",
    promptLabel: "Décrivez le clone IA à générer", placeholder: "Ex : androïde noir, néon bleu, laboratoire cryogénique…" },
  { id: "ugc", code: "AX-07", name: "UGC Studio", kind: "image", lookup_key: "tool_ugc", price: 79,
    tagline: "Contenu visuel automatisé", icon: "Clapperboard", span: "lg:col-span-5",
    desc: "Visuels marketing et lifestyle de qualité studio pour vos campagnes.",
    fields: [
      { key: "name", label: "Nom du personnage", type: "text", placeholder: "Ex : Léa" },
      { key: "age", label: "Âge", type: "number", placeholder: "Ex : 24" },
      { key: "sex", label: "Sexe", type: "select", options: ["Femme", "Homme", "Non-binaire"] },
      { key: "origin", label: "Type", type: "select", options: ["IA", "Réel"] },
    ],
    image: "https://images.unsplash.com/photo-1625314868143-20e93ce3ff33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxjeWJvcmclMjBhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwZGFya3xlbnwwfHx8fDE3ODQzODMzMDB8MA&ixlib=rb-4.1.0&q=85",
    promptLabel: "Décrivez le visuel marketing", placeholder: "Ex : packshot d'un parfum sur socle, lumière studio…" },
  { id: "analytic", code: "AX-08", name: "Analytic Hub", kind: "text", lookup_key: "tool_analytic", price: 69,
    tagline: "Radar de performance", icon: "Radar", span: "lg:col-span-4",
    desc: "Transforme vos données en insights et recommandations chiffrées.",
    image: null, promptLabel: "Collez vos données / contexte", placeholder: "Ex : ventes T1 : jan 12k, fév 9k, mar 15k…" },
  { id: "automation", code: "AX-09", name: "Automation Bot", kind: "text", lookup_key: "tool_automation", price: 99,
    tagline: "Orchestration autonome", icon: "Cog", span: "lg:col-span-3",
    desc: "Conçoit des workflows d'automatisation étape par étape.",
    image: null, promptLabel: "Objectif à automatiser", placeholder: "Ex : envoyer un e-mail + Slack quand un lead s'inscrit…" },
  { id: "video", code: "AX-10", name: "AIBA Video Creator", kind: "video", lookup_key: "tool_video", price: 129,
    tagline: "Génération vidéo IA réelle", icon: "Video", span: "lg:col-span-4",
    desc: "Génère de vraies vidéos IA (jusqu'à 30s) à partir d'une simple description.",
    image: null, promptLabel: "Décrivez la vidéo à générer", placeholder: "Ex : un drone survolant une ville futuriste au coucher du soleil, cinématique…" },
];

export const getTool = (id) => TOOLS.find((t) => t.id === id);

// Outils inclus par plan d'abonnement
export const TOOL_TIERS = {
  writer: "Débutant", chat: "Débutant", clone: "Débutant", ugc: "Débutant", voice: "Débutant",
  seo: "Expert", analytic: "Expert", video: "Expert",
  suite: "Premium", automation: "Premium",
};
export const TIER_BADGE = {
  "Débutant": "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  "Expert": "border-blue-400/40 bg-blue-400/10 text-blue-300",
  "Premium": "border-amber-400/40 bg-amber-400/10 text-amber-300",
};

// Access hierarchy (cumulative). Free (no subscription) unlocks NO AI tool.
const TIER_RANK = { "Débutant": 1, "Expert": 2, "Premium": 3, "Pro": 4 };
const PLAN_RANK = { plan_debutant: 1, plan_expert: 2, plan_premium: 3, plan_pro: 4 };

export const TIER_PLAN_KEY = { "Débutant": "plan_debutant", "Expert": "plan_expert", "Premium": "plan_premium" };

export const canAccessTool = (user, toolId) => {
  if (!user) return false;                 // anon: everything locked
  if (user.role === "admin") return true;
  const need = TIER_RANK[TOOL_TIERS[toolId]] || 1;
  const have = PLAN_RANK[user.subscription] || 0; // no sub = Free = 0
  return have >= need;
};
